import React, { useReducer, useState } from "react";
import axios from "axios";
import moment from "moment";
import ReportContext from "./ReportContext";
import ReportReducer from "./ReportReducer";
import {
  CAMPAIGN_OWNER,
  REPORT_TYPE,
  DATE_RANGE,
  SET_LOADING,
  GET_REPORTS,
  FILTERED_REPORTS,
  GET_REPORTS_ERROR,
} from "../types";

const ReportState = (props) => {
  const initialState = {
    owner: "Aureas",
    report_type_aureas: "Campaign Analytics",
    report_type_alvin: "Angle Analytics",
    date_range: "",
    reports_loading: false,
    reports: null,
    filtered_reports: null,
    media_buyer_reports: null,
    reports_error: null,
  };

  const [state, dispatch] = useReducer(ReportReducer, initialState);
  const [searched_date, setSearchedDate] = useState([]);

  const setOwner = (owner) => {
    dispatch({
      type: CAMPAIGN_OWNER,
      payload: owner,
    });
  };

  const setReportType = (type) => {
    dispatch({
      type: REPORT_TYPE,
      payload: {
        owner: state.owner,
        type,
      },
    });
  };

  const setDateRange = (date_range) => {
    dispatch({
      type: DATE_RANGE,
      payload: date_range,
    });
  };

  const getReportsByDate = async (from, to, day) => {
    dispatch({
      type: SET_LOADING,
    });

    const owner = state.owner;
    const existedDateRange = [];

    for (let x in searched_date) {
      const searched_date_from = searched_date[x]["date_from"];
      const searched_date_to = searched_date[x]["date_to"];
      const searched_full_reports = searched_date[x]["full_reports"];
      const searched_owner = searched_date[x]["owner"];

      existedDateRange.push(searched_date_from + " " + searched_date_to + " " + searched_owner);

      if (from === searched_date_from && to === searched_date_to && owner === searched_owner) {
        dispatch({
          type: GET_REPORTS,
          payload: searched_full_reports,
        });
      }
    }

    try {
      let today_full_reports = [];
      let full_reports = [];

      let reports;

      reports = await axios.post(`${process.env.REACT_APP_SERVER_URL}api/report`, {
        date_from: from,
        date_to: to,
        owner,
      });

      full_reports = reports.data.full_reports;

      // Include Today's Report into Last 7 Days, This Month and Custom Today Reports
      if (["lastSevenDay", "thisMonth", "custom_today"].includes(day)) {
        const dividend = (a, b) => (Number.isFinite(a / b) ? a / b : 0);

        if (owner === "Aureas") {
          // Concat Full Reports
          today_full_reports.forEach((today) => {
            let found = false;

            for (let x in full_reports) {
              const non_today = full_reports[x];

              if (non_today.laptop === today.laptop.trim() && non_today.angle === today.angle.trim()) {
                found = true;

                // Concat Product Report Details
                today.product_details.forEach((today_detail) => {
                  let found_detail = false;

                  for (let x in non_today.product_details) {
                    const non_today_detail = non_today.product_details[x];

                    if (non_today_detail.name === today_detail.name) {
                      found_detail = true;

                      let quantity = non_today_detail.quantity + today_detail.quantity;

                      non_today.product_details[x] = {
                        name: non_today_detail.name,
                        quantity,
                        price: non_today_detail.price,
                      };
                    }
                  }

                  if (!found_detail) non_today.product_details.push(today_detail);
                });

                let visits = non_today.visits + today.visits;
                let clicks = non_today.clicks + today.clicks;
                let conversions = non_today.conversions + today.conversions;
                let revenue = parseFloat(non_today.revenue) + parseFloat(today.revenue);
                let cost = parseFloat(non_today.cost) + parseFloat(today.cost);
                let profit = parseFloat(non_today.profit) + parseFloat(today.profit);
                let ROAS = parseFloat(dividend(revenue, cost)).toFixed(2);
                let CTR = parseFloat(dividend(clicks, visits) * 100).toFixed(2);
                let CV = parseFloat(dividend(conversions, clicks) * 100).toFixed(2);
                let AP = parseFloat(dividend(revenue, conversions)).toFixed(2);

                full_reports[x] = {
                  product_details: non_today.product_details,
                  laptop: non_today.laptop,
                  angle: non_today.angle,
                  media_buyer: non_today.media_buyer,
                  ad_account_status: non_today.ad_account_status,
                  visits,
                  clicks,
                  conversions,
                  revenue: revenue.toFixed(2),
                  cost: cost.toFixed(2),
                  profit: profit.toFixed(2),
                  ROAS,
                  CTR,
                  CV,
                  AP,
                };
              }
            }

            if (!found) full_reports.push(today);
          });
        }
      }

      dispatch({
        type: GET_REPORTS,
        payload: full_reports,
      });

      setSearchedDate((searchedDate) => [
        ...searchedDate,
        {
          date_from: from,
          date_to: to,
          owner,
          full_reports,
        },
      ]);
    } catch (error) {
      dispatch({
        type: GET_REPORTS_ERROR,
        payload: error.response,
      });
    }
  };

  const filterByProfit = (filter) => {
    if (filter) {
      let filtered = [];

      state.reports.map((report) => {
        if (parseFloat(report.profit) !== 0) {
          filtered.push(report);
        }
      });

      dispatch({
        type: FILTERED_REPORTS,
        payload: filtered,
      });
    } else {
      dispatch({
        type: FILTERED_REPORTS,
        payload: null,
      });
    }
  };

  return (
    <ReportContext.Provider
      value={{
        owner: state.owner,
        report_type_aureas: state.report_type_aureas,
        report_type_alvin: state.report_type_alvin,
        date_range: state.date_range,
        reports_loading: state.reports_loading,
        reports: state.reports,
        filtered_reports: state.filtered_reports,
        media_buyer_reports: state.media_buyer_reports,
        reports_error: state.reports_error,
        setOwner,
        setReportType,
        setDateRange,
        getReportsByDate,
        filterByProfit,
      }}
    >
      {props.children}{" "}
    </ReportContext.Provider>
  );
};

export default ReportState;
